import { showErrorSnackbar, showSuccessSnacbar } from '@components/shared-layouts/Snackbar/helper'
import { CustomSubmitButton } from '@components/shared-ui-components/Buttons'
import { CustomNumberField, CustomTextField } from '@components/shared-ui-components/CustomFields'
import OperationSuccessfullyCompletedModal from '@components/shared-ui-components/DynamicForm/OperationSuccessfullyCompletedModal'
import ProgressbarModal from '@components/shared-ui-components/DynamicForm/ProgressbarModal'
import { getDynamicFormValidationSchema } from '@components/shared-ui-components/DynamicForm/helper'
import ProjectContext from '@context/Project/projectContext'
import { Paper } from '@mui/material'
import { startModelBasedAL } from '@services/dashboardService'
import { getProjectType } from '@utils/index'
import { FormikHelpers, useFormik } from 'formik'
import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

const initialDefaultValues = {
  model_1_wandb_id: 'srikeshram/GENIE-2D-CLARIFIER/run_v2gar86z_model:v1',
  model_2_wandb_id: 'srikeshram/GENIE-2D-CLARIFIER/run_v2gar86z_model:v1',
  slice_interval: 3,
}

function ModelBasedALPage() {
  
  const page = 'modelBasedAL'
  
  const { projectId, project_type } = useParams();
  
  const projectType = getProjectType()
  
  const [operationSuccessModal, setOperationSuccessModal] = useState<boolean>(false);

  const [checkLiveStatusModal, setCheckLiveStatusModal] = useState<boolean>(false);
  
  const projectContextInfo = useContext(ProjectContext);
  const { state: projectState, setState: setProjectState } = projectContextInfo;
  
  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    
    console.log('handle submit is running')

    console.log("submit Values ====>", values);
    values["project_id"] = projectId;
    values['project_type'] = project_type
    // Over here we will get api function to be call
    startModelBasedAL(values)
      .then((x: any) => {
        console.log("Response from api", x);
        // Reset the form after success
        actions.resetForm();
        // Enable the form
        actions.setSubmitting(false);
        // Set ProjectContext 
        setProjectState({
          ...projectState,
          processId: x.data?.process_id || x.process_id,
        });
        // show a notification progress has been save
        showSuccessSnacbar(x.data?.message || x.message || 'Operation started successfully');
        // Show Success Modal
        setOperationSuccessModal(true);
      })
      .catch((e: any) => {
        // Over here we need to handle the status codes ===>
        console.log("THis is the error coming", e);
        // showErrorSnackbar
        if (e.status === 400) {
          showErrorSnackbar(e.error.message);
        }
        actions.setSubmitting(false);
      });
  };
  
  const formik = useFormik({
    initialValues: initialDefaultValues,
    enableReinitialize: true, 
    validationSchema: getDynamicFormValidationSchema(page, projectType),
    onSubmit: handleSubmit,
  });

  const {
    handleSubmit: handleSub,
    isSubmitting,
    errors,
    values,
    touched,
    handleChange,
  } = formik || {};
  
  console.log('formik error ===>', formik.errors, isSubmitting)

  const handleOperationModalClose = () => {
    setOperationSuccessModal(false);
  };

  const handleCheckLiveStatusModalClose = () => {
    setCheckLiveStatusModal(false);
  };

  const handleCheckLiveStatus = () => {
    // First we close the operation successful Modal
    setOperationSuccessModal(false);
    setCheckLiveStatusModal(true);
  };

  
  console.log('valuessss----', values, errors)
  
  return (
    <Paper
      elevation={3} // Add shadow effect
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px'
      }}
    >
      <h4>Please fill up the Model Based AL form</h4>
     <form onSubmit={handleSub} style={{ display: "inline-grid" }}>
        
        <CustomTextField
          label={'Model 1 WandB ID'}
          name={'model_1_wandb_id'}
          value={values['model_1_wandb_id']}
          onChange={handleChange}
          error={Boolean(touched['model_1_wandb_id'] && errors['model_1_wandb_id'])}
          helperText={touched['model_1_wandb_id'] && errors['model_1_wandb_id'] ? String(errors['model_1_wandb_id']) : ''}
          sx={{ mb: 2 }}
          disabled={isSubmitting}
        />
        
        <CustomTextField
          label={'Model 2 WandB ID'}
          name={'model_2_wandb_id'}
          value={values['model_2_wandb_id']}
          onChange={handleChange}
          error={Boolean(touched['model_2_wandb_id'] && errors['model_2_wandb_id'])}
          helperText={touched['model_2_wandb_id'] && errors['model_2_wandb_id'] ? String(errors['model_2_wandb_id']) : ''}
          sx={{ mb: 2 }}
          disabled={isSubmitting}
        />

        <CustomNumberField
          label={'Slice Interval'}
          name={'slice_interval'}
          value={values['slice_interval']}
          onChange={handleChange}
          error={Boolean(touched['slice_interval'] && errors['slice_interval'])}
          helperText={touched['slice_interval'] && errors['slice_interval'] ? String(errors['slice_interval']) : ''}
          sx={{ mb: 2 }}
          InputProps={{ inputProps: { min: 1} }}
          disabled={isSubmitting}
        />
        
        <CustomSubmitButton btnName="Submit" isSubmitting={isSubmitting} />
      
      </form>
      
      {/* Dialog for showing the Operation Successful Modal */}
      <OperationSuccessfullyCompletedModal
          open={operationSuccessModal}
          close={handleOperationModalClose}
          handleCheckLiveStatus={handleCheckLiveStatus}
        />
        {/* Dialog for Showing the Check Live status  */}
        {checkLiveStatusModal && (
          <ProgressbarModal
            page={page}
            open={checkLiveStatusModal}
            close={handleCheckLiveStatusModalClose}
          />
        )}
      
      
    </Paper>
  )
}

export default ModelBasedALPage

